module.exports = __webpack_public_path__ + "img/image-user.2793ba25.png";